import { render, staticRenderFns } from "./DetalleContrato.vue?vue&type=template&id=590c5c68&scoped=true"
import script from "./DetalleContrato.vue?vue&type=script&lang=js"
export * from "./DetalleContrato.vue?vue&type=script&lang=js"
import style0 from "./DetalleContrato.vue?vue&type=style&index=0&id=590c5c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c5c68",
  null
  
)

export default component.exports